import React from 'react';
import { Button, Col, Container, Form, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Stepper from './stepper';
import { useForm } from "react-hook-form";
import { Link , useNavigate} from 'react-router-dom';
// import i18n from '../i18n';

// const Step3 = ({prevStep, nextStep, handleChange, changeLanguage, options, values}) => {
const Step3 = ({prevStep, nextStep, handleChange, options, validStates, values}) => {
  const { t } = useTranslation("global");
  const { register, trigger, formState: { errors } } = useForm();

  const navigate = useNavigate();

  const Previous = e => {
    e.preventDefault();
    prevStep();
    navigate(`/calculator/?lan=${values.language}&type=${values.formType}&zip=${values.zipCode}&step=details`);
  }

  const Continue = e => {
    e.preventDefault();

    // validate fields
    trigger()
      .then((r) => {
        // if fields completed as required, move to next step
        if (r === true) {
          nextStep();
          navigate(`/calculator/?lan=${values.language}&type=${values.formType}&zip=${values.zipCode}&step=drivers`);
        }
      })
  }

  const addSelectOptions = (fieldPosition) => {
    // see: https://stackoverflow.com/a/36206330/11748942
    // // console.log('options', options);
    let opts = [];
    opts.push(<option value=''>{t("step3.form.selectors.defaultOption")}</option>); // default option
    var list;
    // console.log('options.enums', options.enums);
    const validStates = Object.keys(options.enums[8].enum.state);
    validStates.forEach(validState => {
      if (values.stateCode === validState) { list = options.enums[fieldPosition].enum.state[validState]; }
    })
    // if (values.stateCode === 'AZ') { list = options.enums[fieldPosition].enum.state.AZ; }
    // if (values.stateCode === 'TX') { list = options.enums[fieldPosition].enum.state.TX; }

    // if (values.stateCode === 'CA') { list = options.enums[fieldPosition].enum.state.CA; }
    // if (values.stateCode === 'CO') { list = options.enums[fieldPosition].enum.state.CO; }
    // if (values.stateCode === 'CT') { list = options.enums[fieldPosition].enum.state.CT; }
    // if (values.stateCode === 'GA') { list = options.enums[fieldPosition].enum.state.GA; }
    // if (values.stateCode === 'PA') { list = options.enums[fieldPosition].enum.state.PA; }
    // if (values.stateCode === 'FL') { list = options.enums[fieldPosition].enum.state.FL; }

    // console.log('List', fieldPosition, options.enums[fieldPosition]);

    for (let i = 0; i < list.length; i++) {
      // spanish options
      if (values.language === 'es' && list[i].spanish_name) {
        opts.push(<option key={list[i].id} value={list[i].id}>{list[i].spanish_name}</option>); // Keys are needed?
      } else {
        // english options
        if (fieldPosition !== 8) {
          opts.push(<option key={list[i].id} value={list[i].id}>{list[i].name}</option>); // Keys are needed?
        } else {
          opts.push(<option key={list[i].id} value={list[i].name}>{list[i].name}</option>); // Keys are needed?
        }
      }
    }
    return opts;
  }

  // test: <button onClick={changeLan}>change lan</button>
  // const changeLan = e => {
  //   e.preventDefault();
  //   changeLanguage();
  // }

  return (
    <Container style={{marginTop:"2%"}}>
      <Row>
        <Col lg={3}></Col>
        <Col lg={7}>
          <div className="page-texts">
            <p className="title">{t("step3.page.title")}</p>
            <p className="subtitle">{t("step3.page.subtitle")}</p>
          </div>
        </Col>
      </Row>

      <Row style={{marginTop:"1rem"}}>
        <Col lg={3}>
          <Stepper step="2" t={t}></Stepper>
        </Col>
        <Col lg={7}>
          <div className="form-texts">
            <p className="title" style={{color:"#253244"}}>{t("step3.form.title")}</p>
            <p className="subtitle" style={{color:"#253244"}}>{t("step3.form.subtitle")}</p>
          </div>

          <Form>

            <Form.Group style={{width:"70%", textAlign:"left"}}>
              <Form.Label className="question-title">{t("step3.form.industry.title")}</Form.Label>
              <Form.Label className="question-subtitle">{t("step3.form.industry.subtitle")}</Form.Label>
              <Form.Select {...register("industry", { required: true })}
                value={values.industry} onChange={handleChange('industry')}>
                {addSelectOptions(0)}
              </Form.Select>
              {errors.industry && <p className="require-field-message">{t('requiredFieldMessage')}</p>}
            </Form.Group>
            <br/><br/>

            <Form.Group style={{width:"70%", textAlign:"left"}}>
              <Form.Label className="question-title">{t("step3.form.mainVehicle.title")}</Form.Label>
              <Form.Label className="question-subtitle">{t("step3.form.mainVehicle.subtitle")}</Form.Label>
              <Form.Select {...register("mainVehicle", { required: true })}
                value={values.mainVehicle} onChange={handleChange('mainVehicle')}>
                {addSelectOptions(1)}
              </Form.Select>
              {errors.mainVehicle && <p className="require-field-message">{t('requiredFieldMessage')}</p>}
            </Form.Group>
            <br/><br/>

            <Form.Group style={{width:"70%", textAlign:"left"}}>
              <Form.Label className="question-title"> {t("step3.form.estimatedValueVehicle.title")} </Form.Label>
              <Form.Label className="question-subtitle">{t("step3.form.estimatedValueVehicle.subtitle")}</Form.Label>
              <Form.Select {...register("estimatedValueVehicle", { required: true })}
                value={values.estimatedValueVehicle} onChange={handleChange('estimatedValueVehicle')}>
                {addSelectOptions(2)}
              </Form.Select>
              {errors.estimatedValueVehicle && <p className="require-field-message">{t('requiredFieldMessage')}</p>}
            </Form.Group>
            <br/><br/>

            <Row>
              <Col lg={4}>
                <Link to = {`/calculator/?lan=${values.language}&type=${values.formType}&zip=${values.zipCode}&step=details`}>
                 <Button variant="outline-dark" onClick={ Previous } style={{width:"100%"}}>{t("step3.form.prevButton")}</Button>
                </Link>
              </Col>
              <Col lg={5}>
                <Link to = {`/calculator/?lan=${values.language}&type=${values.formType}&zip=${values.zipCode}&step=drivers`}>
                  <Button variant="success" onClick={ Continue } style={{width:"100%"}}>{t("step3.form.nextButton")}</Button>
                </Link>
              </Col>
            </Row>
            <br/>

          </Form>
        </Col>
      </Row>
    </Container>
  )
}

export default Step3